export default __webpack_public_path__ + "1081523.png";